import { downloadFile } from "src/app/helpers/utils";
import { Component, OnInit, Input, signal, computed } from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "../../../../core/store";
import { BaseComponent } from "src/app/core/abstracts/baseComponent";
import { Actions } from "@ngrx/effects";
import { AlertService } from "src/app/shared/services/alert.service";
import { OnBoardingDocumentUserModel } from "src/app/models/onBoardingDocumentUserModel";
import { Router, ActivatedRoute } from "@angular/router";
import {
  getOnboardingDocsList,
  loadOnboardingDoc,
} from "src/app/core/store/onboardingdocs/onboardingdocs.actions";

@Component({
    selector: "app-list-my-onboardingdocs",
    templateUrl: "./list-my-onboardingdocs.component.html",
    styleUrls: ["./list-my-onboardingdocs.component.scss"],
    standalone: false
})
export class ListMyOnboardingDocsComponent
  extends BaseComponent
  implements OnInit
{
  onboardingDocs: OnBoardingDocumentUserModel[];
  loadingOnboardingDocsList = false;
  @Input() managedUserId;
  seeOldDocs = false;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (this.route.snapshot.parent.params.userid) {
      this.managedUserId = this.route.snapshot.parent.params.userid;
    }
    this.store.dispatch(getOnboardingDocsList({ userId: this.managedUserId }));
    this.subs.push(
      this.store
        .select((s) => s.onBoardingDocsState.docsList)
        .subscribe((onboardingDocs) => {
          this.onboardingDocs = onboardingDocs;
          if(onboardingDocs != null)
            this.totalRecords.set(onboardingDocs.length)
        }),

      this.store
        .select((s) => s.onBoardingDocsState)
        .subscribe((onBoardingDocsState) => {
          this.loadingOnboardingDocsList =
            onBoardingDocsState.loadingList || onBoardingDocsState.loadingDoc;
        }),
    );
  }

  sign(onboardingDocsUser: OnBoardingDocumentUserModel) {
    this.router.navigate(
      ["../../onboardingdocs/sign/" + onboardingDocsUser.id],
      { relativeTo: this.route },
    );
  }

  fillInfo(onboardingDocsUser: OnBoardingDocumentUserModel) {
    this.router.navigate(
      ["../../onboardingdocs/fill-info/" + onboardingDocsUser.id],
      { relativeTo: this.route },
    );
  }

  fillInfoHR(onboardingDocsUser: OnBoardingDocumentUserModel) {
    this.router.navigate(
      ["../../onboardingdocs/fill-info-hr/" + onboardingDocsUser.id],
      { relativeTo: this.route },
    );
  }

  viewDoc(onboardingDocsUser: OnBoardingDocumentUserModel) {
    this.store.dispatch(
      loadOnboardingDoc({ onboardingDocUserId: onboardingDocsUser.id }),
    );
    const subDocBuffer = this.store
      .select((s) => s.onBoardingDocsState.docArrayBuffer)
      .subscribe((docArrayBuffer) => {
        if (docArrayBuffer) {
          downloadFile(
            new Blob([docArrayBuffer], { type: "application/pdf" }),
            onboardingDocsUser.onBoarding_Document.fileName,
          );
          subDocBuffer.unsubscribe();
        }
      });
  }
}
